// extracted by mini-css-extract-plugin
export default {"root":"MediaView_root__sDxM+","media_frame":"MediaView_media_frame__ms4Ma"};